
export default function ContactInfo() {
  const contactMethods = [
    {
      icon: 'ri-phone-line',
      title: '24/7 Phone Support',
      primary: '+1 (732) 900-3478',
      secondary: 'Available 24/7 for assistance',
      description: 'Speak with our professional customer service team anytime, anywhere.'
    },
    {
      icon: 'ri-mail-line',
      title: 'Email Support',
      primary: 'info@cartogo.co',
      secondary: 'Response within 2 hours',
      description: 'Get detailed assistance and documentation via email within 2 hours.'
    },
    {
      icon: 'ri-chat-3-line',
      title: 'Live Chat',
      primary: 'Available 24/7',
      secondary: 'Average response: &lt; 30 seconds',
      description: 'Instant support through our website chat for quick questions.'
    },
    {
      icon: 'ri-whatsapp-line',
      title: 'WhatsApp Business',
      primary: '+1 (732) 900-3478',
      secondary: 'Business hours: 6 AM - 11 PM EST',
      description: 'Connect with us on WhatsApp for convenient mobile support.'
    }
  ];

  const departments = [
    {
      name: 'Reservations & Bookings',
      phone: '+1 (732) 900-3478',
      email: 'info@cartogo.co',
      hours: '24/7 Available'
    },
    {
      name: 'Corporate Accounts',
      phone: '+1 (732) 900-3478',
      email: 'info@cartogo.co',
      hours: 'Mon-Fri 8 AM - 8 PM EST'
    },
    {
      name: 'Roadside Assistance',
      phone: '+1 (732) 900-3478',
      email: 'info@cartogo.co',
      hours: '24/7 Emergency Support'
    },
    {
      name: 'Billing & Payments',
      phone: '+1 (732) 900-3478',
      email: 'info@cartogo.co',
      hours: 'Mon-Fri 9 AM - 6 PM EST'
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-800 mb-4">Multiple Ways to Reach Us</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Choose your preferred method of communication. Our professional team is ready to assist you with any questions or concerns.
          </p>
        </div>

        {/* Contact Methods */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-20">
          {contactMethods.map((method, index) => (
            <div key={index} className="bg-white rounded-xl p-8 shadow-lg hover:shadow-xl transition-shadow duration-300">
              <div className="w-16 h-16 bg-blue-100 rounded-xl flex items-center justify-center mb-6 mx-auto">
                <i className={`${method.icon} text-2xl text-blue-600`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-4 text-center">{method.title}</h3>
              <div className="text-center mb-4">
                <div className="text-lg font-semibold text-blue-600 mb-1">{method.primary}</div>
                <div className="text-sm text-gray-600" dangerouslySetInnerHTML={{ __html: method.secondary }}></div>
              </div>
              <p className="text-gray-600 text-sm text-center leading-relaxed">{method.description}</p>
            </div>
          ))}
        </div>

        {/* Department Directory */}
        <div className="bg-white rounded-2xl p-8 shadow-lg">
          <h3 className="text-3xl font-bold text-gray-800 mb-8 text-center">Department Directory</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {departments.map((dept, index) => (
              <div key={index} className="border border-gray-200 rounded-lg p-6 hover:border-blue-300 transition-colors duration-200">
                <h4 className="text-xl font-bold text-gray-800 mb-4">{dept.name}</h4>
                <div className="space-y-3">
                  <div className="flex items-center">
                    <i className="ri-phone-line text-blue-600 mr-3"></i>
                    <span className="text-gray-700">{dept.phone}</span>
                  </div>
                  <div className="flex items-center">
                    <i className="ri-mail-line text-blue-600 mr-3"></i>
                    <span className="text-gray-700">{dept.email}</span>
                  </div>
                  <div className="flex items-center">
                    <i className="ri-time-line text-blue-600 mr-3"></i>
                    <span className="text-gray-700">{dept.hours}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
